import type { Difficulty, SessionStats } from '../types';
import { DIFFICULTIES } from '../config';

export function comboMultiplier(combo: number): number {
  return Math.min(2.5, 1 + Math.floor(combo / 5) * 0.1);
}

export function scoreWord(length: number, combo: number, difficulty: Difficulty, timeToTypeMs: number): number {
  const base = length * 10;
  const speedBonus = timeToTypeMs < 1500 ? Math.max(0, Math.round((1500 - timeToTypeMs) / 100)) : 0;
  return Math.round((base + speedBonus) * DIFFICULTIES[difficulty].multiplier * comboMultiplier(combo));
}

export function accuracy(stats: Pick<SessionStats, 'correctKeys' | 'wrongKeys'>): number {
  const total = stats.correctKeys + stats.wrongKeys;
  return total === 0 ? 100 : Math.round((stats.correctKeys / total) * 100);
}

export function wpm(stats: Pick<SessionStats, 'correctKeys' | 'wrongKeys' | 'activePlayMs'>): number {
  if (stats.activePlayMs <= 0) return 0;
  return Math.max(0, Math.round(((stats.correctKeys / 5) / (stats.activePlayMs / 60000)) - (stats.wrongKeys / (stats.activePlayMs / 60000))));
}
